//import React from 'react'
//import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
//import CallRoundedIcon from '@mui/icons-material/CallRounded';
//import WhatsAppIcon from '@mui/icons-material/WhatsApp';
//import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
//import VerifiedIcon from '@mui/icons-material/Verified';
import SettingsIcon from '@mui/icons-material/Settings';
import PaymentsIcon from '@mui/icons-material/Payments';
//import EditIcon from '@mui/icons-material/Edit';
//import CloseIcon from '@mui/icons-material/Close';
//import Box from '@mui/material/Box';
//import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
//import React, { useState } from "react";
import { useSession } from "./SessionContext";
import RenderForm from "./RenderForm";

const DbPhotoGallery = () => {
    const { session } = useSession();

    return (
        <div>
            <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; Photo Gallery</div>
            <div className='ibodywrap'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className='bd-left-panel sticky-position'>
                            <div className='db-leftmenu-panel'>
                                <Link to="/dashboard" className='dbtab-menu'><SettingsIcon /> Dashboard</Link>
                                <Link to="/personal-details" className='dbtab-menu'><SettingsIcon /> Personal Details</Link>
                                <Link to="/business-details" className='dbtab-menu'><SettingsIcon /> Business Details</Link>
                                <Link to="/contact-details" className='dbtab-menu'><SettingsIcon /> Contact Details</Link>
                                <Link to="/photo-gallery" className='dbtab-menu dbm-active'><SettingsIcon /> Photo Gallery</Link>
                                <Link to="/change-password" className='dbtab-menu'><SettingsIcon /> Change Password</Link>
                                <Link to="/payment" className='dbtab-menu' style={{ color: "#fff", background: "#237cdb" }}><PaymentsIcon /> Make Payment</Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        <p style={{ display: "none" }}>User ID: {session?.userid} | Category: {session?.ucategory} | Email: {session?.email}</p>
                        
                        <RenderForm session={session} type="gallery" />

                    </div>
                </div>
            </div>
        </div>
    )
}

export default DbPhotoGallery
